const wealthiestOverview = [
  {
      "city": "New York City",
      "millionaires": "349500",
      "centiMillionaires": "744",
      "billionaires": "60",
      "centiGrowth": "48"
  },
  {
      "city": "The Bay Area",
      "millionaires": "305700",
      "centiMillionaires": "675",
      "billionaires": "68",
      "centiGrowth": "82"
  },
  {
      "city": "Los Angeles",
      "millionaires": "212100",
      "centiMillionaires": "496",
      "billionaires": "43",
      "centiGrowth": "45"
  },
  {
      "city": "Chicago",
      "millionaires": "120500",
      "centiMillionaires": "290",
      "billionaires": "24",
      "centiGrowth": "22"
  },
  {
      "city": "Houston",
      "millionaires": "90900",
      "centiMillionaires": "258",
      "billionaires": "18",
      "centiGrowth": "70"
  },
  {
      "city": "Dallas",
      "millionaires": "68600",
      "centiMillionaires": "125",
      "billionaires": "15",
      "centiGrowth": "75"
  },
  {
      "city": "Seattle",
      "millionaires": "54200",
      "centiMillionaires": "130",
      "billionaires": "11",
      "centiGrowth": "72"
  },
  {
      "city": "Boston",
      "millionaires": "42900",
      "centiMillionaires": "107",
      "billionaires": "8",
      "centiGrowth": "55"
  },
  {
      "city": "Miami",
      "millionaires": "35300",
      "centiMillionaires": "164",
      "billionaires": "15",
      "centiGrowth": "78"
  },
  {
      "city": "Austin",
      "millionaires": "32700",
      "centiMillionaires": "92",
      "billionaires": "10",
      "centiGrowth": "110"
  },
  {
      "city": "Washington, D.C.",
      "millionaires": "28300",
      "centiMillionaires": "88",
      "billionaires": "12",
      "centiGrowth": "75"
  }
];

const totalWorldData = [
  {
      "city": "Total USA",
      "country": "",
      "millionaires": "5492000",
      "centiMillionaires": "9850",
      "billionaires": "788",
      "centiGrowth": "62"
  }
];

export {wealthiestOverview, totalWorldData};